import { __assign } from "tslib";
import React from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import CodeBlock from './components/CodeBlock';
var CodeBlockWithTheme = withTheme(CodeBlock);
var emptyTheme = {};
var ThemeCodeBlock = function (props) { return (React.createElement(ThemeProvider, { theme: emptyTheme },
    React.createElement(CodeBlockWithTheme, __assign({}, props)))); };
export default ThemeCodeBlock;
//# sourceMappingURL=ThemedCodeBlock.js.map